export interface AlarmDTO {
    id: number;
    userId: string;
    createdAt: Date;
    groupId: number | null;
    alarmGroup: AlarmGroupDTO | null;
    phytoViewAlarm: PhytoViewAlarmDto | null;
    stationAlarm: StationAlarmDto | null;
}

export interface AlarmGroupDTO {
    id: number;
    name: string;
    stationAlarms: StationAlarmDto[];
    phytoViewAlarms: PhytoViewAlarmDto[];
}

export interface StationAlarmDto {
    id: number;
    userId: string;
    createdAt: Date;
    metosStationId: number | null;
    pinovaStationId: number | null;
    measurementType: string;
    measurementUnit: string;
    valueRange: ValueRange<number> | null;
    amount: number | null;
    lookbackDays: number | null;
    type: StationAlarmTypeEnum;
}

export interface PhytoViewAlarmDto {
    id: number;
    userId: string;
    createdAt: Date;
    countyId: number;
    jlsId: number;
    fazaRazvojaId: number;
    stetniOrganizamId: number;
    intenzitet: string;
    note: string;
}

export interface ValueRange<T> {
    min: T;
    max: T;
}

export enum StationAlarmTypeEnum {
    None = 0,
    Regular = 1,
    ForSpecificLoockbackDays = 2,
}

export enum NotificationTypeEnum {
    None = 0,
    InApp = 1,
    Web = 2,
    iOS = 3,
    Android = 4,
}
